import { useCallback, useEffect, useRef } from 'react';
import { useAuth } from '@restworld/feature-authentication';
import { isDev } from './use-is-dev-server';
import { Router } from 'next/router';
import posthog from 'posthog-js';
import { usePostHog } from 'posthog-js/react';
export default function usePostHogProvider() {
  var _useAuth = useAuth(),
      user = _useAuth.user,
      isAuthenticated = _useAuth.isAuthenticated;

  var posthogClient = usePostHog();
  var oldUrlRef = useRef('');
  useEffect(function () {
    var _process$env$NEXT_PUB;

    posthog.init((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_POSTHOG_KEY) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '', {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
      // Enable debug mode in development
      loaded: function loaded(posthog) {
        if (isDev) posthog.debug();
      },
      autocapture: false,
      opt_in_site_apps: true
    });

    var handleRouteChange = function handleRouteChange() {
      return posthog === null || posthog === void 0 ? void 0 : posthog.capture('$pageview');
    };

    var handleRouteChangeStart = function handleRouteChangeStart() {
      return posthog === null || posthog === void 0 ? void 0 : posthog.capture('$pageleave', {
        $current_url: oldUrlRef.current
      });
    };

    Router.events.on('routeChangeComplete', handleRouteChange);
    Router.events.on('routeChangeStart', handleRouteChangeStart);
    return function () {
      Router.events.off('routeChangeComplete', handleRouteChange);
      Router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, []);
  useEffect(function () {
    if (!isAuthenticated || !user) return;
    posthogClient === null || posthogClient === void 0 ? void 0 : posthogClient.identify(user.id, {
      email: user.email,
      name: user.name,
      first_name: user.name,
      last_name: user.surname,
      created: user.inserted_at,
      avatar: user.picture,
      type: user.type,
      phone: user.phone_number,
      organization_source: user.organization_source,
      using_ppu_business_model: user === null || user === void 0 ? void 0 : user.using_ppu_business_model
    });

    if (user.organization_id) {
      posthogClient === null || posthogClient === void 0 ? void 0 : posthogClient.group('organization', user.organization_id, {
        name: user.business_name,
        using_ppu_business_model: user.using_ppu_business_model
      });
    }
  }, [isAuthenticated, user, posthogClient]);
  var trackEvent = useCallback(function (eventName, eventProperties) {
    console.info('PostHog Event:', eventName, eventProperties);
    if (!posthogClient) return;
    posthogClient.capture(eventName, eventProperties);
  }, [posthogClient]);
  return {
    trackEvent: trackEvent
  };
}